module.exports = __webpack_public_path__ + "img/screen_1.288abd38.jpg";